import { render } from "./GeoPoint.vue?vue&type=template&id=45021c1a"
import script from "./GeoPoint.vue?vue&type=script&lang=js"
export * from "./GeoPoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__